import Waiter from "./Waiter";

export default Waiter;
